<script setup lang="ts">
import NProgress from 'nprogress'
import { FirebaseAuthService } from '@/services/auth/firebase-auth-service'
import { AuthProvider } from '@/services/auth/auth-service'
import AccountPageContent from './components/AccountPageContent.vue'

const upgradeStore = useUpgradeStore()
const { leadProfile } = storeToRefs(upgradeStore)
const router = useRouter()

definePage({
  path: '/upgrade/account',
  meta: {
    permissionResource: 'Lead',
    shell: {
      showLeadPromotion: false,
    },
  },
})

const { t } = useI18n()
const toast = useToast()

if (leadProfile.value?.hasAccount) {
  toast.info(t('leads.upgrade.account.alreadyHasAccount', { email: leadProfile.value.email }))
  router.replace({ name: '/upgrade/billing' })
}

const authStore = useAuthStore()

const submitting = ref(false)

async function register(payload: {
  firstName: string,
  lastName: string,
  email: string,
  password: string 
}) {
  submitting.value = true
  NProgress.start()
  const response = await upgradeStore.createFirebaseAccount(payload)
  if (response) {
    try {
      await authStore.logout()
      const firebaseAuthService = await authStore.getAuthService<FirebaseAuthService>(AuthProvider.Firebase, FirebaseAuthService, authStore.firebaseAuth)

      await firebaseAuthService.loginWithToken(response.token)

      await Promise.all([ authStore.fetchEmployerAccess(), authStore.fetchEmployerProfile() ])
    } catch (error) {
      console.error(error)
      authStore.setAuthState(AuthState.AuthenticationError)
    }
    upgradeStore.goToPage(1)
  }
  NProgress.done()
  submitting.value = false
}
</script>

<template>
  <AccountPageContent
    :first-name="leadProfile?.firstName"
    :last-name="leadProfile?.lastName"
    :email="leadProfile?.email"
    :submitting="submitting"
    @submit="register"
  />
</template>
